import React from 'react'
import CardGenerated from './CardGenerated'
import GeneratedCarousel from './GeneratedCarousel'

const ProfileGenerator = ({show, toggleView,itemSelected, generatedOutfits, scheme,userId}) => {
    //console.log("DISPLAY,", show)
    let filterNotSelectedItemTypes = []
    let matchedShoes = []
    if(generatedOutfits.length > 0) {
        filterNotSelectedItemTypes = generatedOutfits.filter(x => x.itemType != itemSelected.itemType)
        matchedShoes = filterNotSelectedItemTypes[0].footwears
    }
    
    return (
        <>
            <div className={`fixed ${show ? "block" : "hidden"} w-full h-full top-0 b-0 left-0 right-0 cursor-pointer bg-black z-50 bg-opacity-80 overflow-y-auto`}>
                <div className="px-10 container mx-auto">
                    <div className="mt-12  w-full text-white relative">
                        {/* <GeneratedCarousel outfits={generatedOutfits}/> */}
                        <div className="flex flex-col justify-center  rounded-3xl space-y-6 ">
                            <h1 className="font-bold text-sm lg:text-lg text-center w-64 lg:w-80 text-white self-center">{`Your Generated Outfits with ${scheme} Colour Scheme`} </h1>
                            {itemSelected.itemType == "TOP" ? <CardGenerated item={itemSelected} userId={userId} /> : <GeneratedCarousel   outfits={generatedOutfits} userId={userId}/>}
                            {itemSelected.itemType == "BOTTOMS" ? <CardGenerated item={itemSelected} userId={userId} className="self-center"/> : <GeneratedCarousel outfits={generatedOutfits} userId={userId}/>}
                            {itemSelected.itemType == "FOOTWEAR" ? <CardGenerated item={itemSelected} userId={userId} className="self-center"/> : <GeneratedCarousel outfits={matchedShoes} userId={userId}/>}
                           
                        </div>
                        <div className="absolute top-1 right-0" onClick={toggleView}>
                            <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                            </svg>
                        </div>
                    </div>
                </div>
                
            </div>
            
        </>
    )
}

export default ProfileGenerator